import { render, staticRenderFns } from "./EndPoint.vue?vue&type=template&id=4894b52f&"
import script from "./EndPoint.vue?vue&type=script&lang=js&"
export * from "./EndPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports